// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NdQKKfeqJDDdX3 {
  display: block;
  margin-bottom: 4px;
  overflow: hidden;
  overflow-wrap: break-word;
  white-space: normal;
}
.NdQKKfeqJDDdX3,
.NdQKKfeqJDDdX3:hover,
.NdQKKfeqJDDdX3:active {
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.NdQKKfeqJDDdX3:focus {
  outline: none;
}
.uo5N2Ob6aXs81a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `NdQKKfeqJDDdX3`,
	"truncate": `uo5N2Ob6aXs81a`
};
export default ___CSS_LOADER_EXPORT___;
